module.exports = __webpack_public_path__ + "img/1728955164337-Screenshot_15-10-2024_9193_www.instagram.com.jpeg.66eebab3.webp";